<template>
  <!-- brand logo -->
  <router-link
    to="/"
    class="brand-logo d-flex align-center"
  >
    <v-img
      :src="appLogo"
      width="100px"
      alt="logo"
      class="me-3 "
    ></v-img>

    <!-- <h2 class="text--primary">
      {{ appName }}
    </h2> -->
  </router-link>
  <!--/ brand logo -->
</template>

<script>
import themeConfig from '@themeConfig'

export default {
  name: "Logo",

  setup() {
    return {
      // themeConfig
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,
    }
  }
}
</script>

<style type="scss" scoped></style>